




























































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";
import {
  CLIENT_CHARTS_STORE_KEY,
  clientChartsStore
} from "./ClientCharts/_store";

import ClientForm from "./ClientForm/ClientForm.vue";
import DocumentFeed from "../../components/Details/DocumentFeed/DocumentFeed.vue";
import ClientDealList from "./ClientDealList/ClientDealList.vue";
import ClientProps from "./ClientProps/ClientProps.vue";
import ClientPriceList from "./ClientPriceList/ClientPriceList.vue";
import ClientDealScheduling from "./ClientDealScheduling/ClientDealScheduling.vue";
import ClientComplaints from "./ClientComplaints/ClientComplaints.vue";
import ClientChildrenList from "./ClientChildrenList/ClientChildrenList.vue";
import ClientBuyersList from "./ClientBuyersList/ClientBuyersList.vue";
import ClientCharts from "./ClientCharts/ClientCharts.vue";

const tabMapper: any = {
  documents: 0,
  deals: 1,
  props: 2,
  price: 3,
  schedule: 4,
  complaints: 5
};

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "filter",

      "document",
      "meta"
    ])
  },
  components: {
    ClientForm,
    DocumentFeed,
    ClientDealList,
    ClientProps,
    ClientPriceList,
    ClientDealScheduling,
    ClientComplaints,
    ClientChildrenList,
    ClientBuyersList,
    ClientCharts
  }
})
export default class ClientDetails extends Vue {
  @Prop() params!: any;

  document!: any;

  public TAB_VIEW_DETAILS = 0;
  public TAB_VIEW_FORM = 1;
  public TAB_VIEW_STATISTIC = 2;

  hActiveTab: number | null = null;

  get isDistributor() {
    return this.document && this.document.type_code === "distributor";
  }

  get activeTab() {
    return this.hActiveTab
      ? this.hActiveTab
      : this.isNew
      ? this.TAB_VIEW_FORM
      : this.TAB_VIEW_DETAILS;
  }

  set activeTab(value: number) {
    this.hActiveTab = value;
  }

  public activeDetailTab = 0;

  get config() {
    return this.params || this.$route.params;
  }

  get isModal() {
    return this.params;
  }

  get isNew() {
    return this.config.id == "new";
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
    // До первого рендера ClientCharts: иначе mapState(clientDetailsCharts) падает.
    // @ts-ignore
    if (!(CLIENT_CHARTS_STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(CLIENT_CHARTS_STORE_KEY, clientChartsStore);
    }
  }

  public mounted() {
    if (this.$route.query.tab) {
      // @ts-ignore
      this.activeDetailTab = tabMapper[this.$route.query.tab];
    }
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
    this.activeDetailTab = this.$route.query.tab
      ? parseInt(this.$route.query.tab as any)
      : 0;
  }

  // @Watch('$route.params')
  public loadDocumentData(nV?: any, oV?: any) {
    if (!this.isModal) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
    }
  }

  public toArchive(cliend_id: any) {
    this.$store.dispatch(`${STORE_KEY}/toArchive`, cliend_id).then(() => {
      this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
    });
  }

  public toUnarchive(cliend_id: any) {
    this.$store.dispatch(`${STORE_KEY}/toUnarchive`, cliend_id).then(() => {
      this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
    });
  }

  onTab(tab: number) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        // @ts-ignore
        tab
      }
    });
  }

  onMainTabInput(value: number) {
    if (value === this.TAB_VIEW_STATISTIC && process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.debug("[client-charts] tab_open", {
        clientId: this.document && this.document.id,
        routeName: this.$route && this.$route.name,
        isModal: !!this.isModal
      });
    }
  }

  onNeedDataReload(documentId: string) {
    if (!this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, {
        ...this.config,
        silence: true
      });
    } else {
      this.$router.replace({
        name: "client-details",
        params: {
          id: documentId
        }
      });
    }
  }

  public goBack() {
    if (!this.params) {
      this.$router.push({ name: "client-list" });
    } else {
      this.$router.back();
      this.$emit("close");
    }
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    try {
      this.$store.unregisterModule(CLIENT_CHARTS_STORE_KEY);
    } catch (e) {
      /* ignore */
    }
    // this.$store.unregisterModule(STORE_KEY);
  }
}
